export interface ConsultantProcessApiConfig {
	baseUrl: string;
}

/**
 * Loads the [consultant process api configuration from environment variables.
 *
 * @return the loaded ConsultantProcessAPi object.
 * @throws IllegalStateException if the consultant process api config is not set.
 */
export function loadConsultantProcessApiConfig(): ConsultantProcessApiConfig {
	const { CONSULTANT_PROCESS_API } = process.env;

	if (!CONSULTANT_PROCESS_API) {
		throw new Error("CONSULTANT_PROCESS_API config is not set.");
	}

	return {
		baseUrl: CONSULTANT_PROCESS_API
	};
}
